import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  textHead: {
    fontWeight: 600,
    fontSize: 14
  }
};

const enhance = compose();

const tableHead = enhance(
  ({ order, orderBy, onRequestSort, roles, classes }) => {
    return (
      <TableHead>
        <TableRow>
          <TableCell sortDirection={orderBy === 'shopId' ? order : false}>
            <TableSortLabel
              className={classes.textHead}
              active={orderBy === 'shopId'}
              direction={order}
              onClick={() => {
                onRequestSort('shopId');
              }}
            >
              店舗ID
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
            <TableSortLabel
              className={classes.textHead}
              active={orderBy === 'shopName'}
              direction={order}
              onClick={() => {
                onRequestSort('shopName');
              }}
            >
              店舗名
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'shopStatus' ? order : false}>
            <TableSortLabel
              className={classes.textHead}
              active={orderBy === 'shopStatus'}
              direction={order}
              onClick={() => {
                onRequestSort('shopStatus');
              }}
            >
              店舗状況
            </TableSortLabel>
          </TableCell>
          <TableCell
            sortDirection={orderBy === 'streetAddress' ? order : false}
          >
            <TableSortLabel
              className={classes.textHead}
              active={orderBy === 'streetAddress'}
              direction={order}
              onClick={() => {
                onRequestSort('streetAddress');
              }}
            >
              住所
            </TableSortLabel>
          </TableCell>
          {(roles.isGroup || roles.isSecretariat) && (
            <TableCell sortDirection={orderBy === 'status' ? order : false}>
              <TableSortLabel
                className={classes.textHead}
                active={orderBy === 'status'}
                direction={order}
                onClick={() => {
                  onRequestSort('status');
                }}
              >
                紐付け状況
              </TableSortLabel>
            </TableCell>
          )}
          {(roles.isGroup || roles.isSecretariat) && <TableCell />}
          {/* <TableCell sortDirection={orderBy === 'phone' ? order : false}>
          <TableSortLabel
            active={orderBy === 'phone'}
            direction={order}
            onClick={() => {
              onRequestSort('phone');
            }}
          >
            電話番号
          </TableSortLabel>
        </TableCell> */}
        </TableRow>
      </TableHead>
    );
  }
);

export default withStyles(styles)(tableHead);
